import React from 'react';
import { RoutePermittedRole } from '@crema/constants/AppEnums';
import BlankPage from '../../../../../libs/modules/src/lib/blankPage';

const Account = React.lazy(() => import('../../modules/account/MyProfile'));
const Cafe24Auth = React.lazy(() => import('../../modules/auth/Cafe24Auth'));
const JoinComplete = React.lazy(() => import('../../modules/auth/AuthPage/JoinEmail/JoinComplete'));

export const accountPagesConfigs = [
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blank',
    element: <BlankPage />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/myPage',
    element: <Account />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/cafe24Auth',
    element: <Cafe24Auth />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/signup/complete',
    element: <JoinComplete />,
  },
];
